(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('[data-scroll-text-reveal-compact]').forEach(function (section) {
    var chars = section.querySelectorAll('.scroll-reveal-compact__char');
    if (!chars.length) return;

    var ticking = false;

    function update() {
      var rect = section.getBoundingClientRect();
      var viewportH = window.innerHeight;
      var sectionH = section.offsetHeight;

      /* Raw progress: 0 when section bottom enters viewport, 1 when section top exits */
      var raw = (viewportH - rect.top) / (viewportH + sectionH);

      /* Compress: reveal happens between 20% and 65% of travel so it feels snappy */
      var start = 0.20, end = 0.65;
      var progress = Math.min(Math.max((raw - start) / (end - start), 0), 1);

      var revealCount = Math.round(progress * chars.length);

      for (var i = 0; i < chars.length; i++) {
        if (i < revealCount) {
          chars[i].classList.add('is-revealed');
        } else {
          chars[i].classList.remove('is-revealed');
        }
      }

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    /* Only listen to scroll when section is near viewport */
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      } else {
        window.removeEventListener('scroll', onScroll);
      }
    }, { rootMargin: '200px 0px' });

    observer.observe(section);
  });
})();
